export enum UserFlowAdvisorProUpgradeFlowValue {
  NOT_INTERESTED = 'not_interested'
}
